import React, { Fragment } from "react";

import img13 from "../../../images/service/P2P Crypto Exchange Development/1.png";
import img14 from "../../../images/service/P2P Crypto Exchange Development/2.png";
import img15 from "../../../images/service/P2P Crypto Exchange Development/3.png";

import sIcon1 from "../../../images/icon/service-icon01.svg";
import sIcon2 from "../../../images/icon/service-icon02.svg";
import sIcon3 from "../../../images/icon/service-icon03.svg";
import sIcon4 from "../../../images/icon/service-icon04.svg";
import sIcon5 from "../../../images/icon/service-icon05.svg";
import sIcon6 from "../../../images/icon/service-icon06.svg";

import Header from "../../../components/Header/Header";
import PageTitle from "../../../components/pagetitle/PageTitle";
import Scrollbar from "../../../components/scrollbar/scrollbar";
import Footer from "../../../components/footer/Footer";

import HeroSection from "../../../components/PageSection/HeroSection";
import TheorySection from "../../../components/PageSection/Theory";
import ServiceCardsSection from "../../../components/PageSection/ServiceCardSection";
import Benefit from "../../../components/PageSection/BenefitSection";
import KeyFeaturesSection from "../../../components/PageSection/KeyFeature";
import WhyChooseUsSection from "../../../components/PageSection/WhyChooseUsSection";
import FaqSection from "../../../components/PageSection/FAQsection";
import FinalCenteredCTA from "../../../components/PageSection/FinalCTA";

// --------------------------------------------------
// DATA
// --------------------------------------------------

const serviceCards = [
  {
    icon: sIcon1,
    title: "P2P Exchange Platform Development",
    content:
      "Custom-built peer-to-peer crypto exchange platforms enabling direct user-to-user trading.",
  },
  {
    icon: sIcon2,
    title: "Escrow Smart Contracts",
    content:
      "Secure escrow mechanisms that protect funds until trade conditions are met.",
  },
  {
    icon: sIcon3,
    title: "Dispute Management System",
    content:
      "Integrated dispute resolution workflows to handle trade conflicts securely.",
  },
];

const benefits = [
  {
    title: "Direct Peer-to-Peer Trading",
    description:
      "Users trade directly without intermediaries or centralized custody.",
    icon: sIcon1,
  },
  {
    title: "Enhanced Security",
    description:
      "Escrow-based transactions minimize fraud and counterparty risks.",
    icon: sIcon2,
  },
  {
    title: "Lower Transaction Costs",
    description:
      "Reduced platform fees compared to centralized exchanges.",
    icon: sIcon3,
  },
  {
    title: "Global Accessibility",
    description:
      "Users can trade globally with flexible payment methods.",
    icon: sIcon4,
  },
  {
    title: "High Privacy",
    description:
      "Minimal data exposure with optional KYC configurations.",
    icon: sIcon5,
  },
  {
    title: "Scalable Architecture",
    description:
      "Supports high user growth and transaction volumes.",
    icon: sIcon6,
  },
];

const faqs = [
  {
    q: "What is a P2P crypto exchange?",
    a: "A P2P crypto exchange enables users to trade cryptocurrencies directly with each other without centralized intermediaries.",
  },
  {
    q: "How are funds protected during P2P trades?",
    a: "Funds are secured using escrow smart contracts until both parties complete the trade.",
  },
  {
    q: "Can P2P exchanges support fiat payments?",
    a: "Yes. P2P platforms can support multiple local and global payment methods.",
  },
  {
    q: "Are P2P exchanges scalable?",
    a: "Yes. Our P2P exchange solutions are designed to scale with growing demand.",
  },
];

// --------------------------------------------------
// PAGE COMPONENT
// --------------------------------------------------

export default function P2PCryptoExchangeDevelopment() {
  return (
    <Fragment>
      <Header />

      <PageTitle
        pageTitle="P2P Crypto Exchange Development"
        pagesub="Enable secure peer-to-peer crypto trading platforms"
      />

      {/* ================= HERO ================= */}
      <HeroSection
        title={
          <>
            Build a Secure{" "}
            <span className="gradient-text">P2P Crypto Exchange</span>
          </>
        }
        subtitle={`P2P crypto exchanges allow users to trade directly with one another
using secure escrow mechanisms. We build scalable, secure, and feature-rich
P2P trading platforms for global markets.`}
        buttonText="Build P2P Exchange"
        buttonLink="/contact"
        image={img13}
        imageAlt="P2P Crypto Exchange Development"
      />

      {/* ================= THEORY 1 ================= */}
      <TheorySection
        title="What Is P2P Crypto Exchange Development?"
        image={img14}
        paragraphs={[
          "P2P crypto exchange development focuses on creating decentralized marketplaces where users can trade digital assets directly with one another. These platforms remove intermediaries, enabling greater privacy, control, and flexibility for traders.",
          "By leveraging escrow smart contracts and automated trade workflows, P2P exchanges ensure that transactions are completed securely while reducing counterparty risks.",
        ]}
      />

      {/* ================= THEORY 2 ================= */}
      <TheorySection
        title="Why P2P Exchanges Are Gaining Popularity"
        image={img15}
        paragraphs={[
          "P2P exchanges are increasingly popular due to their decentralized nature, lower fees, and global accessibility. They empower users to choose their preferred payment methods and trade terms.",
          "For businesses, P2P platforms offer regulatory flexibility, reduced infrastructure costs, and the ability to serve emerging markets where centralized exchanges may face limitations.",
        ]}
      />

      {/* ================= SERVICES ================= */}
      <ServiceCardsSection
        title="Our P2P Crypto Exchange Services"
        cards={serviceCards}
      />

      {/* ================= BENEFITS ================= */}
      <Benefit
        title="Benefits of P2P Crypto Exchange Development"
        benefits={benefits}
      />

      {/* ================= KEY FEATURES ================= */}
      <KeyFeaturesSection
        title="Key Features of P2P Crypto Exchanges"
        subtitle="Designed for trustless, flexible, and secure trading."
        features={[
          {
            icon: sIcon1,
            title: "Escrow Protection",
            description:
              "Funds are held securely until trade conditions are met.",
          },
          {
            icon: sIcon2,
            title: "Multi-Payment Support",
            description:
              "Supports bank transfers, wallets, and local payment methods.",
          },
          {
            icon: sIcon3,
            title: "Dispute Resolution",
            description:
              "Built-in dispute management for trade conflicts.",
          },
          {
            icon: sIcon4,
            title: "User Reputation System",
            description:
              "Ratings and reviews enhance trader trust.",
          },
          {
            icon: sIcon5,
            title: "KYC & AML Options",
            description:
              "Configurable compliance workflows.",
          },
          {
            icon: sIcon6,
            title: "Scalable Platform",
            description:
              "Handles high user activity and trade volumes.",
          },
        ]}
      />

      {/* ================= WHY CHOOSE US ================= */}
      <WhyChooseUsSection
        items={[
          "Expert P2P Exchange Developers",
          "Secure Escrow-Based Architecture",
          "End-to-End Platform Delivery",
        ]}
      />

      {/* ================= FAQ ================= */}
      <FaqSection faqs={faqs} />

      {/* ================= CTA ================= */}
      <FinalCenteredCTA />

      <Footer />
      <Scrollbar />
    </Fragment>
  );
}
